import { render } from "./groups.html?vue&type=template&id=122b69d0&external"
import script from "./groups.js?vue&type=script&lang=js&external"
export * from "./groups.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__